import { get } from './client'

export interface MjLogEntry {
  id: number
  user_id: number
  mj_id?: string
  action?: string
  prompt?: string
  status?: string
  progress?: string
  image_url?: string
  submit_time?: number
  finish_time?: number
  channel_id?: number
  state?: string
  fail_reason?: string
  code?: number
}

export interface MjLogListResponse {
  items: MjLogEntry[]
  total: number
  page: number
  page_size: number
}

export async function getMjLogsApi(params?: {
  p?: number
  page_size?: number
  user_id?: number
  mj_id?: string
  channel_id?: number
  start_timestamp?: number
  end_timestamp?: number
}): Promise<MjLogListResponse> {
  return get<MjLogListResponse>('/api/mj/', params)
}

export async function getSelfMjLogsApi(params?: {
  p?: number
  page_size?: number
}): Promise<MjLogListResponse> {
  return get<MjLogListResponse>('/api/mj/self/', params)
}
